import React, { useState, useEffect } from "react";
import axios from "axios";
import {Modal, Button, Table, Input, message, Upload, Radio, Empty, Switch, Checkbox } from "antd";
import DefaultLayout from '../components/DefaultLayout';
import config from "../config";
import { jwtDecode } from "jwt-decode";

const { Search } = Input;
const Inventory = () => {
    const apiBaseUrl = config.REACT_APP_API_BASE_URL;
    const [itemsData, setItemsData] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [quantities, setQuantities] = useState({});
    const [originalData, setOriginalData] = useState([]);
    const [filterType, setFilterType] = useState('all');
    const [editMode, setEditMode] = useState(false);
    const [updatedItems, setUpdatedItems] = useState([]);
    const [filteredData, setFilteredData] = useState(itemsData);
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [currentUser, setCurrentUser] = useState(null); 
    const [poNumbers, setPoNumbers] = useState({});
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
    });

    const searchFields = ['name', 'poNumber'];
    const handleSearch = (searchValue, selectedFilterType = filterType, dataSource = itemsData) => {
        setSearchText(searchValue);
        setFilterType(selectedFilterType);

        const lowerSearchValue = searchValue.toLowerCase();
        let data = [...dataSource];

        // Search
        if (searchValue) {
        data = data.filter(item =>
            searchFields.some(field =>
            item[field] && String(item[field]).toLowerCase().includes(lowerSearchValue)
            )
        );
        }

        // Filter by type
        if (selectedFilterType !== 'all') {
        data = data.filter(item => item.type === selectedFilterType);
        }

        setFilteredData(data);
    };
    const getAllItems = async () => {
        try {

            const { data } = await axios.get(`${apiBaseUrl}/api/products/get-product`);

            const filteredData = data.filter(
                item => item.hasOwnProperty('quantity') && item.quantity !== null
            );
            console.log("get",data);
            
            setItemsData(data);
            setOriginalData(data);
            handleSearch(searchText, filterType, data);
        } catch (error) {
            console.log(error);
        }

    };

    useEffect(() => {
        getAllItems();
    }, []);

    // useEffect(() => {
    //     let data = [...itemsData];

    //     // Search by text
    //     if (searchText) {
    //         data = data.filter(item => {
    //             return searchFields.some(field =>
    //                 item[field] && String(item[field]).toLowerCase().includes(searchText.toLowerCase())
    //             );
    //         });
    //     }


    //     // Filter by type (example, if you have a field like "category")
    //     if (filterType !== 'all') {
    //         data = data.filter(item => item.type === filterType);
    //     }

    //     setFilteredData(data);
    // }, [searchText, filterType, itemsData]);

    const toggleEditMode = async () => {
        if (editMode) {
            // If currently in edit mode, save changes
            await submit();
        } else {
            // If not in edit mode, enter edit mode
            setEditMode(true);
        }
    };

        const handleQuantityChange = (id, newQuantity, poNumber = poNumbers[id] || '') => {
            setItemsData(prev =>
                prev.map(item =>
                    item._id === id ? { ...item, quantity: newQuantity } : item
                )
            );
            setFilteredData(prev =>
                prev.map(item =>
                    item._id === id ? { ...item, quantity: newQuantity } : item
                )
            );
            setUpdatedItems(prev => {
                const existing = prev.find(i => i.id === id);
                if (existing) {
                    return prev.map(i => (i.id === id ? { ...i, quantity: newQuantity } : i));
                } else {
                    return [...prev, { id, quantity: newQuantity }];
                }
            });

            if (poNumber) {
                setPoNumbers(prev => ({ ...prev, [id]: poNumber }));
            }
        };

    const columns = [
        {
            title: "Image",
            dataIndex: "image",
            width: 100,
            render: (image, record) => (
                // <img src={record.image} alt={record.name} height="60" width="60" />
                <img
                    src={record.image}
                    alt={record.name}
                    height="60"
                    width="60"
                    style={{ cursor: 'pointer', borderRadius: 6, objectFit: 'cover' }}
                    onClick={() => {
                        setPreviewImage(record.image);
                        setPreviewVisible(true);
                    }}
                />

            ),
        },
        { 
            title: "Name", 
            dataIndex: "name",
            width: 250,
            render: (text) => (
                <div style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>{text}</div>
            ),
            sorter: (a, b) => a.name.localeCompare(b.name),
            showSorterTooltip: false,
        },
        { 
            title: "Category", 
            dataIndex: "category",
            width: 180,
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Checkbox.Group
                        style={{ display: 'flex', flexDirection: 'column' }}
                        options={Array.from(new Set(itemsData.map(item => item.category))).map(cat => ({ label: cat, value: cat }))}
                        value={selectedKeys}
                        onChange={(keys) => {
                        setSelectedKeys(keys);
                        confirm({ closeDropdown: false });
                        }}
                />
                <Button
                onClick={() => {
                    clearFilters();
                    confirm();
                }}
                size="small"
                style={{ width: '100%', marginTop: 8 }}
                >
                Reset
                </Button>
            </div>
            ),
            onFilter: (value, record) => record.category === value,
        },
        {
            title: "Quantity",
            dataIndex: "quantity",
            width: 150,
            sorter: (a, b) => (a.quantity || 0) - (b.quantity || 0),
            showSorterTooltip: false,
            render: (quantity, record) => (
                <div style={{ width: '100%', position: 'relative' }}>
                    {editMode ? (
                        <Input
                            type="number"
                            value={quantity}
                            onChange={e =>
                                handleQuantityChange(record._id, Number(e.target.value))
                            }
                            style={{
                                width: '100%',
                                padding: '4px 8px',
                                borderRadius: '4px',
                                fontSize: '1rem',
                                lineHeight: '1.5',
                                height: '32px', // Matches AntD default input height
                                boxSizing: 'border-box',
                            }}
                        />
                    ) : (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                height: '32px', // Match Input height
                                padding: '4px 8px',
                                lineHeight: '1.5',
                                boxSizing: 'border-box',
                            }}
                        >
                            {(() => {
                                if (quantity === 0) return 0;
                                if (quantity == null) return 'NIL';
                                
                                // Check if item has volume tracking
                                if (record.unit && record.volumePerUnit && record.usedVolume !== undefined) {
                                    const totalVolume = quantity * record.volumePerUnit;
                                    const remainingVolume = totalVolume - (record.usedVolume || 0);
                                    const fullBottles = Math.floor(remainingVolume / record.volumePerUnit);
                                    const partialVolume = remainingVolume % record.volumePerUnit;
                                    
                                    // Color coding based on stock level
                                    let color = '#52c41a'; // Green - plenty of stock
                                    if (fullBottles < 5) color = '#faad14'; // Yellow - getting low
                                    if (fullBottles < 2) color = '#ff4d4f'; // Red - almost empty
                                    
                                    if (partialVolume > 0) {
                                        return (
                                            <span style={{ color }}>
                                                {fullBottles} bottles - {Math.round(partialVolume)}ml remaining
                                            </span>
                                        );
                                    } else {
                                        return (
                                            <span style={{ color }}>
                                                {fullBottles} bottles
                                            </span>
                                        );
                                    }
                                }
                                
                                // Apply color coding to ALL quantities (not just volume tracking items)
                                let color = '#52c41a'; // Green - plenty of stock
                                if (quantity < 5) color = '#faad14'; // Yellow - getting low
                                if (quantity < 2) color = '#ff4d4f'; // Red - almost empty
                                
                                return (
                                    <span style={{ color }}>
                                        {quantity}
                                    </span>
                                );
                            })()}
                        </div>
                    )}
                </div>
            )
        },
        {
            title: "PO/Order Number",
            dataIndex: "poNumber",
            width: 150,
            sorter: (a, b) => {
                const aVal = a.poNumber || '';
                const bVal = b.poNumber || '';
                // sort by number / sort by string.
                if (!isNaN(Number(aVal)) && !isNaN(Number(bVal))) {
                    return Number(aVal) - Number(bVal);
                }
                return String(aVal).localeCompare(String(bVal));
            },
            render: (_, record) => {
                // Get PO number from state or from the product data
                const currentPoNumber = poNumbers[record._id] ?? record.poNumber ?? '-';
                
                return (
                    <div style={{ width: '100%' }}>
                        {editMode ? (
                            <Input
                                placeholder="Enter PO #"
                                value={poNumbers[record._id] ?? record.poNumber ?? ''}
                                onChange={e => {
                                    // Update both state and the product data
                                    setPoNumbers(prev => ({ 
                                        ...prev, 
                                        [record._id]: e.target.value 
                                    }));
                                    setItemsData(prev => 
                                        prev.map(item => 
                                            item._id === record._id 
                                                ? { ...item, poNumber: e.target.value } 
                                                : item
                                        )
                                    );
                                    handleQuantityChange(record._id, record.quantity, e.target.value);
                                }}
                                style={{
                                    width: '100%',
                                    padding: '4px 8px',
                                    borderRadius: '4px',
                                    fontSize: '0.9rem',
                                    lineHeight: '1.5',
                                    height: '32px',
                                    boxSizing: 'border-box'
                                }}
                            />
                        ) : (
                            <div style={{ padding: '4px 8px' }}>
                                {currentPoNumber}
                            </div>
                        )}
                    </div>
                );
            }
        },
        {   title: "Unit of Measure", 
            dataIndex: "uom", 
            width: 100,
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Checkbox.Group
                    style={{ display: 'flex', flexDirection: 'column' }}
                    options={Array.from(new Set(itemsData.map(item => item.unit)))
                        .filter(Boolean)
                        .map(unit => ({ label: unit, value: unit }))}
                    value={selectedKeys}
                    onChange={(keys) => {
                        setSelectedKeys(keys);
                        confirm({ closeDropdown: false }); // 勾选即筛选
                    }}
                    />
                    <Button
                    onClick={() => {
                        clearFilters();
                        confirm();
                    }}
                    size="small"
                    style={{ width: '100%', marginTop: 8 }}
                    >
                    Reset
                    </Button>
                </div>
            ),
            onFilter: (value, record) => record.unit === value,
            render: (value) => (value !== null && value !== undefined ? value : 'NIL'),
        },
        {   title: "Qty per unit", 
            dataIndex: "quantityUnit", 
            width: 100,
            sorter: (a, b) => {
                // 兼容数字和字符串
                const aVal = Number(a.quantityUnit) || 0;
                const bVal = Number(b.quantityUnit) || 0;
                return aVal - bVal;
            },
            render: (value) => (value !== null && value !== undefined ? value : 'NIL'),
        },
        {
            title: "Est. Can Sell (Units)",
            dataIndex: "estimated",
            width: 150,
            sorter: (a, b) => {
                // 兼容数字和字符串
                const aVal = Math.floor((a.quantity || 0) / (a.quantityUnit || 1));
                const bVal = Math.floor((b.quantity || 0) / (b.quantityUnit || 1));
                return aVal - bVal;
            },
            render: (_, record) => {
                const { quantity, quantityUnit } = record;
                    const est = quantity === null || quantity === undefined
                    ? 'NIL'
                    : Math.floor(quantity / (quantityUnit || 1));
                return <span>{est}</span>;
            }
        },
        {
            title: "Availability",
            dataIndex: "status",
            width: 120,
            render: (status) => (status ? "Available" : "Unavailable"),
            filters: [
                {
                    text: "Available",
                    value: true,
                },
                {
                    text: "Not Available",
                    value: false,
                },
            ],
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                <Checkbox.Group
                style={{ display: 'flex', flexDirection: 'column' }}
                options={[
                    { label: 'Available', value: true },
                    { label: 'Unavailable', value: false },
                ]}
                value={selectedKeys}
                onChange={(keys) => {
                    setSelectedKeys(keys);
                    confirm({ closeDropdown: false });
                }}
                />
                <Button
                onClick={() => {
                    clearFilters();
                    confirm();
                }}
                size="small"
                style={{ width: '100%', marginTop: 8 }}
                >
                Reset
                </Button>
            </div>
            ),
            onFilter: (value, record) => record.status === value,
        },
        {
            title: "Stock Status",
            dataIndex: "stockStatus",
            key: "stockStatus",
            width: 150,
            render: (text, record) => {
                if (record.quantity === 0) {
                    return (
                        <div
                            style={{
                                color: '#ff4d4f',
                                fontWeight: 600,
                                fontSize: 14,
                                background: '#fff1f0',
                                borderRadius: 4,
                                padding: '4px 8px',
                                display: 'inline-block'
                            }}
                        >
                            Out of Stock
                        </div>
                    );
                }
                if (record.quantity == null || String(record.quantity).toUpperCase() === "NIL") {
                    return (
                        <div
                            style={{
                                color: '#52c41a',
                                fontWeight: 600,
                                fontSize: 14,
                                background: '#f6ffed',
                                borderRadius: 4,
                                padding: '4px 8px',
                                display: 'inline-block'
                            }}
                        >
                            Unlimited Stock
                        </div>
                    );
                }
                return null;
            },
            filters: [
                { text: "Out of Stock", value: "outofstock" },
                { text: "Unlimited Stock", value: "unlimited" },
            ],
            filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                <div style={{ padding: 8 }}>
                    <Checkbox.Group
                        style={{ display: 'flex', flexDirection: 'column' }}
                        options={[
                            { label: 'Out of Stock', value: 'outofstock' },
                            { label: 'Unlimited Stock', value: 'unlimited' },
                        ]}
                        value={selectedKeys}
                        onChange={(keys) => {
                            setSelectedKeys(keys);
                            confirm({ closeDropdown: false });
                        }}
                    />
                    <Button
                        onClick={() => {
                            clearFilters();
                            confirm();
                        }}
                        size="small"
                        style={{ width: '100%', marginTop: 8 }}
                    >
                        Reset
                    </Button>
                </div>
            ),
            onFilter: (value, record) => {
                if (value === "outofstock") return record.quantity === 0;
                if (value === "unlimited") return record.quantity == null || String(record.quantity).toUpperCase() === "NIL";
                return true;
            },
        },
    ];

    const exportToCSV = () => {
        if (!filteredData || filteredData.length === 0) return;

        // Step 1: Define which columns to export
        const exportFields = ['name', 'quantity', 'category', 'status'];

        // Optional: Friendly column headers
        const headers = {
            name: 'Name',
            quantity: 'Quantity',
            category: 'Category',
            status: 'Status',
        };

        const csvRows = [];

        csvRows.push(exportFields.map(key => headers[key] || key).join(','));

        filteredData.forEach(item => {
            const row = exportFields.map(key => {
                let val = item[key];
                if (key === 'status') {
                    // Translate boolean to readable text
                    val = val ? 'Available' : 'Unavailable';
                }
                if (val == null) val = '';
                if (typeof val === 'string') {
                    val = val.replace(/"/g, '""'); // Escape quotes
                    return `"${val}"`;
                }
                return val;
            });
            csvRows.push(row.join(','));
        });
        //date time
        const now = new Date();

        const datePart = now.toISOString().split('T')[0];

        let hours = now.getHours();
        const minutes = now.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        const timePart = `${hours}-${minutes}${ampm}`;

        const csvString = csvRows.join('\n');
        const blob = new Blob([csvString], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Inventory_${datePart}_${timePart}.csv`;
        link.click();
        window.URL.revokeObjectURL(url);
    };


    useEffect(() => {
        const auth = JSON.parse(localStorage.getItem("auth"));
        if (auth?.token) {
            try {
                const decoded = jwtDecode(auth.token);
                setCurrentUser(decoded.userId); // Just set userId
                console.log(decoded.userId)
            } catch (err) {
                console.error("Invalid token", err);
                localStorage.removeItem("auth");
            }
        }
    }, []);

    const submit = async () => {
        try {
            if (updatedItems.length === 0) {
                message.info("No changes to submit.");
                setEditMode(false);
                return;
            }

            const auth = JSON.parse(localStorage.getItem("auth"));
            const decoded = auth?.token ? jwtDecode(auth.token) : null; 
            const userId = decoded?.userId || currentUser || "Unknown"; 

            const payload = updatedItems.map(item => ({
                ...item,
                userId,
                poNumber: poNumbers[item.id] || itemsData.find(p => p._id === item.id)?.poNumber || ''
            }));

            console.log("payy", payload);

            const response = await axios.put(`${apiBaseUrl}/api/products/update-multi`, payload);

            if (response.data.status !== 200) {
                throw new Error("Failed to update items.");
            }
            message.success("Items updated successfully!");

            await getAllItems();

            setUpdatedItems([]);
            setEditMode(false);

        } catch (error) {
            console.error(error);
            message.error("An error occurred while updating items.");
        }
    };

    return <DefaultLayout searchPlaceholder="Item Name / PO number" onSearch={handleSearch}>
        <div className="page-header"
            style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '10px',      
            }}>

            <h1 className="page-title">Inventory</h1>
            
            <div className="d-flex align-items-center">
                
                <Button 
                    type="primary" 
                    className="me-3" 
                    onClick={toggleEditMode}
                    style={{
                        backgroundColor: editMode ? '#4CAF50' : '#1890ff',
                        color: 'white',
                        border: 'none',
                        borderRadius: 'var(--main-radius)',
                        fontWeight: '600',
                        fontSize: '15px',
                        padding: '8px 20px',
                        display: 'flex',
                        alignItems: 'center',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    {editMode ? 'Save Changes' : 'Update'}
                </Button>
                <Button type="primary" onClick={exportToCSV}>
                    Export
                </Button>

            </div>
        </div>

        {/* <div className="d-flex justify-content-end">
            <Button className="btn btn-primary mb-2" onClick={exportToCSV}>
                Export
            </Button>
        </div> */}

        {/* <div className="d-flex justify-content-between align-items-center">
            <h1>Inventory List</h1>

            <div className="d-flex align-items-center">
                {editMode && (
                    <>
                        <Button
                            className="me-4"
                            onClick={toggleEditMode}
                            style={{
                                backgroundColor: '#FF0000',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                padding: '8px 20px',
                                fontWeight: 'bold',
                                display: 'flex',
                                alignItems: 'center',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            }}
                        >
                            Cancel
                        </Button>

                        <Button
                            className="me-4"
                            onClick={submit}
                            style={{
                                backgroundColor: '#4CAF50',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                padding: '8px 20px',
                                fontWeight: 'bold',
                                display: 'flex',
                                alignItems: 'center',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            }}
                        >
                            Confirm
                        </Button>
                    </>
                )}

                <Button className="btn btn-primary me-3" onClick={toggleEditMode}>
                    Update
                </Button>

                <Search
                    placeholder="Search items..."
                    onChange={e => setSearchText(e.target.value)}
                    style={{ width: 200 }}
                    allowClear
                /> 
            </div>

        </div> */}

        <Table columns={columns} dataSource={filteredData} rowKey="_id" bordered 
            //add pagination
            pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            pageSizeOptions: ['10', '20', '50', '100'],
            showSizeChanger: filteredData.length > 10,
            showTotal: (total, range) => `Showing ${range[0]}–${range[1]} of ${total} items`,
            onChange: (page, pageSize) => setPagination({ current: page, pageSize }),
            }} 
        />

        <Modal
            open={previewVisible}
            footer={null}
            onCancel={() => setPreviewVisible(false)}
            centered
            transitionName=""  // 禁用动画
            maskTransitionName=""  // 禁用遮罩动画
            width={400}
            bodyStyle={{ 
                padding: 0, 
                background: '#fff',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 400,
            }}
            style={{
                top: '30%',  // 确保 Modal 整体居中
                transform: 'translateY(-10%)',  // 修正垂直偏移
                opacity: previewVisible ? 1 : 1, // 避免淡入动画
                pointerEvents: previewVisible ? 'auto' : 'none',
            }}
        >
            <img
                alt="category"
                style={{ 
                    width: '100%', 
                    maxWidth: 400, 
                    maxHeight: 400, 
                    objectFit: 'contain', 
                    display: 'block'
                }}
                src={previewImage}
            />
        </Modal>


    </DefaultLayout>

};

export default Inventory;